export default "__VITE_ASSET__Zl9Uuf8p__"